module.exports = __webpack_public_path__ + "img/md3img.ff29be0b.png";